// Loader.js
import React from 'react';

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-sky-700 mt-[-320px]"></div>
    </div>
  );
};

export default Loader;
